import { createReducer } from '../utils/reducers';
import {
    CHECK_ACCESS_REQUEST,
    CHECK_ACCESS_SUCCESS,
    CHECK_ACCESS_FAILURE,
    FETCH_ASSET_REQUEST,
    FETCH_ASSET_FAILURE,
    FETCH_ASSET_SUCCESS,
    FIND_EXTERNAL_ASSET_REQUEST,
    FIND_EXTERNAL_ASSET_SUCCESS,
    FIND_EXTERNAL_ASSET_FAILURE,
} from '../actions/assets';
import {
    ACCESS_FEES_SUCCESS,
    ACCESS_FEES_REQUEST,
    ACCESS_FEES_FAILURE,
} from '../actions/accessFees';
import { LOGOUT_USER_SUCCESS } from '../actions/user';
import keys from 'lodash/keys';
import forEach from 'lodash/forEach';
import moment from 'moment';

export default createReducer(
    {},
    {
        [CHECK_ACCESS_REQUEST]: (state, action) => {
            return {
                ...state,
                isFetching: true,
                [action.data.id]: {
                    ...state[action.data.id],
                    hasAccess: false,
                },
            };
        },
        [CHECK_ACCESS_SUCCESS]: (state, action) => {
            return {
                ...state,
                isFetching: false,
                [action.data.id]: {
                    ...state[action.data.id],
                    hasAccess: true,
                    ...action.data,
                },
            };
        },
        [CHECK_ACCESS_FAILURE]: (state, action) => {
            return {
                ...state,
                isFetching: false,
                [action.data.id]: {
                    ...state[action.data.id],
                    hasAccess: false,
                    ...action.data.asset,
                },
            };
        },
        [FETCH_ASSET_REQUEST]: (state, action) => {
            return {
                ...state,
                isFetching: true,
            };
        },
        [FETCH_ASSET_SUCCESS]: (state, action) => {
            const asset = state[action.data.id];
            if (asset && asset.hasAccess) {
                return state;
            }

            const now = moment.utc();
            const customExpFees = action.data.access_fees.filter(item => {
                return (
                    item.access_type.name !== 'ppv_custom' ||
                    (item.access_type.name === 'ppv_custom' &&
                        !now.isAfter(moment(item.expires_at * 1000).utc()))
                );
            });

            return {
                ...state,
                isFetching: false,
                [action.data.id]: {
                    ...action.data,
                    access_fees: customExpFees,
                },
            };
        },
        [FETCH_ASSET_FAILURE]: (state, action) => {
            let copy = Object.assign({}, state);
            delete copy[action.data.id];

            return copy;
        },
        [FIND_EXTERNAL_ASSET_SUCCESS]: (state, action) => {
            const asset = state[action.data.id];
            if (asset && asset.hasAccess) {
                return state;
            }

            return {
                ...state,
                isFetching: false,
                [action.data.id]: {
                    ...action.data,
                },
            };
        },
        [ACCESS_FEES_SUCCESS]: (state, action) => {
            const now = moment.utc();
            const customExpFees = action.data.accessFees.filter(item => {
                return (
                    item.access_type.name !== 'ppv_custom' ||
                    (item.access_type.name === 'ppv_custom' &&
                        !now.isAfter(moment(item.expires_at * 1000).utc()))
                );
            });

            return {
                ...state,
                [action.data.id]: {
                    ...state[action.data.id],
                    access_fees: customExpFees,
                },
                isFeeFetched: true,
            };
        },
        [ACCESS_FEES_REQUEST]: (state, action) => {
            return {
                ...state,
                isFeeFetched: false,
            };
        },
        [ACCESS_FEES_FAILURE]: state => {
            return {
                ...state,
                isFeeFetched: true,
            };
        },
        [LOGOUT_USER_SUCCESS]: state => {
            forEach(keys(state), key => {
                if (!isNaN(key)) {
                    state[key] = {
                        ...state[key],
                        hasAccess: false,
                    };
                }
            });

            return state;
        },
    }
);



// WEBPACK FOOTER //
// ./src/reducers/assets.js